export enum BookingSource {
    Customer,
    Google,
    Merchant,
}
